// extracted by mini-css-extract-plugin
module.exports = {"SelectedEntity":"EntitySwitcher_SelectedEntity__30S4g","EntityItem":"EntitySwitcher_EntityItem__2SSyx"};